// @generated by protobuf-ts 2.8.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/app/v1/app_resource.proto" (package "c1.api.app.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import { MessageType } from "@protobuf-ts/runtime";
import { AppEntitlementView } from "./app_entitlement";
import { Facets } from "../../search/v1/facet";
import { AppUserType } from "./app_user";
import { Struct } from "../../../../google/protobuf/struct";
import { ActorObjectPermissions } from "../../iam/v1/authorization";
import { Any } from "../../../../google/protobuf/any";
import { FieldMask } from "../../../../google/protobuf/field_mask";
import { Timestamp } from "../../../../google/protobuf/timestamp";
import { User } from "../../user/v1/user";
import { AppEntitlement } from "./app_entitlement";
import { AppUser } from "./app_user";
import { App } from "./app";
/**
 * @generated from protobuf message c1.api.app.v1.HighRiskRolesAndGrantsCountRequest
 */
export interface HighRiskRolesAndGrantsCountRequest {
    /**
     * @generated from protobuf field: bool onGoing = 1;
     */
    onGoing: boolean;
}
/**
 * @generated from protobuf message c1.api.app.v1.HighRiskRolesAndGrantsCountResponse
 */
export interface HighRiskRolesAndGrantsCountResponse {
    /**
     * @generated from protobuf field: int64 Count = 1 [json_name = "Count"];
     */
    count: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.HighRiskRolesAndCountStruct
 */
export interface HighRiskRolesAndCountStruct {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppResource resource = 1;
     */
    resource?: AppResource;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppResourceType resource_type = 2;
     */
    resourceType?: AppResourceType;
    /**
     * @generated from protobuf field: int64 Count = 3 [json_name = "Count"];
     */
    count: number;
    /**
     * @generated from protobuf field: c1.api.app.v1.App app = 4;
     */
    app?: App;
}
/**
 * @generated from protobuf message c1.api.app.v1.HighRiskRolesAndGrantsRequest
 */
export interface HighRiskRolesAndGrantsRequest {
    /**
     * @generated from protobuf field: bool onGoing = 1;
     */
    onGoing: boolean;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.HighRiskRolesAndGrantsResponse
 */
export interface HighRiskRolesAndGrantsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.HighRiskRolesAndCountStruct list = 1;
     */
    list: HighRiskRolesAndCountStruct[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.HighRiskRolesAndGrantsEntitlementsRequest
 */
export interface HighRiskRolesAndGrantsEntitlementsRequest {
    /**
     * @generated from protobuf field: bool onGoing = 1;
     */
    onGoing: boolean;
    /**
     * @generated from protobuf field: int32 page_size = 2;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 3;
     */
    pageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.HighRiskRolesAndGrantsStruct
 */
export interface HighRiskRolesAndGrantsStruct {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppResource resource = 1;
     */
    resource?: AppResource;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppResourceType resource_type = 2;
     */
    resourceType?: AppResourceType;
    /**
     * @generated from protobuf field: c1.api.app.v1.App app = 4;
     */
    app?: App;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUser app_user = 5;
     */
    appUser?: AppUser;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlement entitlement = 6;
     */
    entitlement?: AppEntitlement;
    /**
     * @generated from protobuf field: c1.api.user.v1.User user = 7;
     */
    user?: User;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deprovision_at = 8;
     */
    deprovisionAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.app.v1.HighRiskRolesAndGrantsEntitlementsResponse
 */
export interface HighRiskRolesAndGrantsEntitlementsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.HighRiskRolesAndGrantsStruct list = 1;
     */
    list: HighRiskRolesAndGrantsStruct[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * The app resource expand mask lets you get information about related objects from the request.
 *
 * @generated from protobuf message c1.api.app.v1.AppResourceExpandMask
 */
export interface AppResourceExpandMask {
    /**
     * The app resource expanded fields. Maybe be any combination of "*", "app_id", "app_resource_type_id".
     *
     * @generated from protobuf field: repeated string paths = 1;
     */
    paths: string[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppResourceServiceGetRequest
 */
export interface AppResourceServiceGetRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_resource_type_id = 2;
     */
    appResourceTypeId: string;
    /**
     * @generated from protobuf field: string id = 3;
     */
    id: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppResourceExpandMask expand_mask = 4;
     */
    expandMask?: AppResourceExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppResourceServiceListRequest
 */
export interface AppResourceServiceListRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string app_id = 3;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_resource_type_id = 4;
     */
    appResourceTypeId: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppResourceExpandMask expand_mask = 5;
     */
    expandMask?: AppResourceExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppResourceServiceUpdateRequest
 */
export interface AppResourceServiceUpdateRequest {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppResource app_resource = 1;
     */
    appResource?: AppResource;
    /**
     * @generated from protobuf field: google.protobuf.FieldMask update_mask = 2;
     */
    updateMask?: FieldMask;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppResourceExpandMask expand_mask = 3;
     */
    expandMask?: AppResourceExpandMask;
}
/**
 * Search for app resources based on some filters.
 *
 * @generated from protobuf message c1.api.app.v1.SearchAppResourceTypesRequest
 */
export interface SearchAppResourceTypesRequest {
    /**
     * The pageSize where 10 <= pageSize <= 100, default 25.
     *
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * The pageToken field.
     *
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * Fuzzy search the display name of resource types.
     *
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * A list of resource type IDs to exclude from the search.
     *
     * @generated from protobuf field: repeated string exclude_resource_type_ids = 4;
     */
    excludeResourceTypeIds: string[];
    /**
     * A list of resource type IDs to restrict the search by.
     *
     * @generated from protobuf field: repeated string resource_type_ids = 5;
     */
    resourceTypeIds: string[];
    /**
     * A list of app IDs to restrict the search by.
     *
     * @generated from protobuf field: repeated string app_ids = 6;
     */
    appIds: string[];
    /**
     * A list of resource type trait IDs to restrict the search by.
     *
     * @generated from protobuf field: repeated string resource_type_trait_ids = 7;
     */
    resourceTypeTraitIds: string[];
    /**
     * A list of resource type trait IDs to exclude from the search.
     *
     * @generated from protobuf field: repeated string exclude_resource_type_trait_ids = 8;
     */
    excludeResourceTypeTraitIds: string[];
    /**
     * A list of app user IDs to restrict the search by.
     *
     * @generated from protobuf field: repeated string app_user_ids = 9;
     */
    appUserIds: string[];
    /**
     * Exact match on display name
     *
     * @generated from protobuf field: string display_name = 10;
     */
    displayName: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppResourceRef
 */
export interface AppResourceRef {
    /**
     * @generated from protobuf field: string id = 1;
     */
    id: string;
    /**
     * @generated from protobuf field: string app_id = 2;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_resource_type_id = 3;
     */
    appResourceTypeId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppResourcesRequest
 */
export interface SearchAppResourcesRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string exclude_resource_ids = 4;
     */
    excludeResourceIds: string[];
    /**
     * @generated from protobuf field: repeated string resource_ids = 5;
     */
    resourceIds: string[];
    /**
     * @generated from protobuf field: repeated string resource_type_ids = 6;
     */
    resourceTypeIds: string[];
    /**
     * @generated from protobuf field: string app_id = 7;
     */
    appId: string;
    /**
     * @generated from protobuf field: repeated string resource_type_trait_ids = 8;
     */
    resourceTypeTraitIds: string[];
    /**
     * @generated from protobuf field: repeated string exclude_resource_type_trait_ids = 9;
     */
    excludeResourceTypeTraitIds: string[];
    /**
     * @generated from protobuf field: repeated string app_user_ids = 10;
     */
    appUserIds: string[];
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppResourceRef refs = 11;
     */
    refs: AppResourceRef[];
    /**
     * @generated from protobuf field: bool exclude_deleted_resource_bindings = 12;
     */
    excludeDeletedResourceBindings: boolean;
    /**
     * @generated from protobuf field: repeated string owner_user_ids = 13;
     */
    ownerUserIds: string[];
}
/**
 * The SearchAppResourceTypesResponse message contains a list of results and a nextPageToken if applicable.
 *
 * @generated from protobuf message c1.api.app.v1.SearchAppResourceTypesResponse
 */
export interface SearchAppResourceTypesResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppResourceType list = 1;
     */
    list: AppResourceType[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size.
     * The server returns one page of results and the nextPageToken until all results are retreived.
     * To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppResourcesResponse
 */
export interface SearchAppResourcesResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppResourceView list = 1;
     */
    list: AppResourceView[];
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * The app resource view returns an app resource with paths for items in the expand mask filled in when this response is returned and a request expand mask has "*" or "app_id" or "resource_type_id".
 *
 * @generated from protobuf message c1.api.app.v1.AppResourceView
 */
export interface AppResourceView {
    /**
     * The app resource object being returned by the request.
     *
     * @generated from protobuf field: c1.api.app.v1.AppResource app_resource = 1;
     */
    appResource?: AppResource;
    /**
     * JSONPATH expression indicating the location of the App object in the array
     *
     * @generated from protobuf field: string app_path = 2;
     */
    appPath: string;
    /**
     * JSONPATH expression indicating the location of the Resource Type object in the array
     *
     * @generated from protobuf field: string resource_type_path = 3;
     */
    resourceTypePath: string;
    /**
     * JSONPATH expression indicating the location of the Parent Resource Type object in the array
     *
     * @generated from protobuf field: string parent_resource_type_path = 4;
     */
    parentResourceTypePath: string;
    /**
     * JSONPATH expression indicating the location of the Parent Resource object in the array
     *
     * @generated from protobuf field: string parent_resource_path = 5;
     */
    parentResourcePath: string;
    /**
     * The permissions the current user has on this resource.
     *
     * @generated from protobuf field: c1.api.iam.v1.ActorObjectPermissions object_permissions = 6;
     */
    objectPermissions?: ActorObjectPermissions;
}
/**
 * The app resource message is a single resource that can have entitlements.
 *
 * @generated from protobuf message c1.api.app.v1.AppResource
 */
export interface AppResource {
    /**
     * The app that this resource belongs to.
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * The resource type that this resource is.
     *
     * @generated from protobuf field: string app_resource_type_id = 2;
     */
    appResourceTypeId: string;
    /**
     * The id of the resource.
     *
     * @generated from protobuf field: string id = 3;
     */
    id: string;
    /**
     * The datetime, in RFC3339 format, of when the AppResource was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 4;
     */
    createdAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the AppResource was last updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 5;
     */
    updatedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the AppResource was deleted.
     *
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 6;
     */
    deletedAt?: Timestamp;
    /**
     * The display name for this resource.
     *
     * @generated from protobuf field: string display_name = 7;
     */
    displayName: string;
    /**
     * The description set for the resource.
     *
     * @generated from protobuf field: string description = 8;
     */
    description: string;
    /**
     * A custom description that can be set for a resource.
     *
     * @generated from protobuf field: string custom_description = 9;
     */
    customDescription: string;
    /**
     * The number of grants to this resource.
     *
     * @generated from protobuf field: int64 grant_count = 10;
     */
    grantCount: number;
    /**
     * The parent resource type id, if this resource is a child of another resource.
     *
     * @generated from protobuf field: string parent_app_resource_type_id = 11;
     */
    parentAppResourceTypeId: string;
    /**
     * The parent resource id, if this resource is a child of another resource.
     *
     * @generated from protobuf field: string parent_app_resource_id = 12;
     */
    parentAppResourceId: string;
    /**
     * @generated from protobuf oneof: metadata
     */
    metadata: {
        oneofKind: "secretTrait";
        /**
         * The secret trait information, only populated for resources that have the secret trait type.
         * Contains metadata about the secret like creation time and last used time.
         *
         * @generated from protobuf field: c1.api.app.v1.SecretTrait secret_trait = 100;
         */
        secretTrait: SecretTrait;
    } | {
        oneofKind: undefined;
    };
    /**
     * @generated from protobuf field: string match_baton_id = 13;
     */
    matchBatonId: string;
    /**
     * Additional metadata about the resource provided by the connector.
     *
     * @generated from protobuf field: google.protobuf.Struct profile = 14;
     */
    profile?: Struct;
}
/**
 * @generated from protobuf message c1.api.app.v1.SecretTrait
 */
export interface SecretTrait {
    /**
     * @generated from protobuf field: string identity_app_user_id = 1;
     */
    identityAppUserId: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp secret_created_at = 2;
     */
    secretCreatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp secret_expires_at = 3;
     */
    secretExpiresAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp last_used_at = 4;
     */
    lastUsedAt?: Timestamp;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppResourceTypeRef
 */
export interface AppResourceTypeRef {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string id = 2;
     */
    id: string;
}
/**
 * The AppResourceType is referenced by an app entitlement defining its resource types. Commonly things like Group or Role.
 *
 * @generated from protobuf message c1.api.app.v1.AppResourceType
 */
export interface AppResourceType {
    /**
     * The ID of the app that is associated with the app resource type
     *
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * The unique ID for the app resource type.
     *
     * @generated from protobuf field: string id = 2;
     */
    id: string;
    /**
     * The datetime, in RFC3339 format, of when the app resource type was created.
     *
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3;
     */
    createdAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the app resource type was last updated.
     *
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4;
     */
    updatedAt?: Timestamp;
    /**
     * The datetime, in RFC3339 format, of when the app resource type was deleted.
     *
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 5;
     */
    deletedAt?: Timestamp;
    /**
     * The display name of the app resource type.
     *
     * @generated from protobuf field: string display_name = 6;
     */
    displayName: string;
    /**
     * Associated trait ids
     *
     * @generated from protobuf field: repeated string trait_ids = 7;
     */
    traitIds: string[];
}
/**
 * The AppResourceTypeView message.
 *
 * @generated from protobuf message c1.api.app.v1.AppResourceTypeView
 */
export interface AppResourceTypeView {
    /**
     * The app resource type object being returned by the request.
     *
     * @generated from protobuf field: c1.api.app.v1.AppResourceType app_resource_type = 1;
     */
    appResourceType?: AppResourceType;
    /**
     * JSONPATH expression indicating the location of the App object in the  array
     *
     * @generated from protobuf field: string app_path = 2;
     */
    appPath: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppResourceTypeTrait
 */
export interface AppResourceTypeTrait {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string id = 2;
     */
    id: string;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp created_at = 3;
     */
    createdAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp updated_at = 4;
     */
    updatedAt?: Timestamp;
    /**
     * @generated from protobuf field: google.protobuf.Timestamp deleted_at = 5;
     */
    deletedAt?: Timestamp;
    /**
     * @generated from protobuf field: string display_name = 6;
     */
    displayName: string;
}
/**
 * The app resource service get response contains the app resource view and array of expanded items indicated by the request's expand mask.
 *
 * @generated from protobuf message c1.api.app.v1.AppResourceServiceGetResponse
 */
export interface AppResourceServiceGetResponse {
    /**
     * A view of the app resource, contains the serialized app resource object and the path of the app resource.
     *
     * @generated from protobuf field: c1.api.app.v1.AppResourceView app_resource_view = 1;
     */
    appResourceView?: AppResourceView;
    /**
     * List of serialized related objects.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
}
/**
 * The AppResourceServiceListResponse message contains a list of results and a nextPageToken if applicable.
 *
 * @generated from protobuf message c1.api.app.v1.AppResourceServiceListResponse
 */
export interface AppResourceServiceListResponse {
    /**
     * The list of results containing up to X results, where X is the page size defined in the request.
     *
     * @generated from protobuf field: repeated c1.api.app.v1.AppResourceView list = 1;
     */
    list: AppResourceView[];
    /**
     * List of serialized related objects.
     *
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
    /**
     * The nextPageToken is shown for the next page if the number of results is larger than the max page size.
     * The server returns one page of results and the nextPageToken until all results are retreived.
     * To retrieve the next page, use the same request and append a pageToken field with the value of nextPageToken shown on the previous page.
     *
     * @generated from protobuf field: string next_page_token = 3;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppResourceServiceUpdateResponse
 */
export interface AppResourceServiceUpdateResponse {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppResourceView app_resource_view = 1;
     */
    appResourceView?: AppResourceView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppResourceRollupItem
 */
export interface AppResourceRollupItem {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppResourceView item = 1;
     */
    item?: AppResourceView;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlement entitlements = 2;
     */
    entitlements: AppEntitlement[];
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppResourceRollupRequest
 */
export interface SearchAppResourceRollupRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * @generated from protobuf field: repeated string exclude_resource_ids = 4;
     */
    excludeResourceIds: string[];
    /**
     * @generated from protobuf field: repeated string resource_ids = 5;
     */
    resourceIds: string[];
    /**
     * @generated from protobuf field: repeated string resource_type_ids = 6;
     */
    resourceTypeIds: string[];
    /**
     * @generated from protobuf field: repeated string resource_type_trait_ids = 8;
     */
    resourceTypeTraitIds: string[];
    /**
     * @generated from protobuf field: repeated string exclude_resource_type_trait_ids = 9;
     */
    excludeResourceTypeTraitIds: string[];
    /**
     * @generated from protobuf field: repeated string app_ids = 10;
     */
    appIds: string[];
    /**
     * @generated from protobuf field: repeated string risk_level_ids = 11;
     */
    riskLevelIds: string[];
    /**
     * @generated from protobuf field: repeated string compliance_framework_ids = 12;
     */
    complianceFrameworkIds: string[];
    /**
     * @generated from protobuf field: repeated string exclude_app_ids = 13;
     */
    excludeAppIds: string[];
    /**
     * If true, exclude resources that have an automation attached to them from the search.
     *
     * @generated from protobuf field: bool exclude_automated_resources = 14;
     */
    excludeAutomatedResources: boolean;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppResourceRollupResponse
 */
export interface SearchAppResourceRollupResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppResourceRollupItem list = 1;
     */
    list: AppResourceRollupItem[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppResourceTypesRollupRequest
 */
export interface SearchAppResourceTypesRollupRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * A list of app IDs to restrict the search by.
     *
     * @generated from protobuf field: repeated string app_ids = 4;
     */
    appIds: string[];
    /**
     * If true, exclude resources that have an automation attached to them from the search.
     *
     * @generated from protobuf field: bool exclude_automated_resources = 5;
     */
    excludeAutomatedResources: boolean;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppResourceTypesRollupResponse
 */
export interface SearchAppResourceTypesRollupResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppResourceTypeRollupItem list = 1;
     */
    list: AppResourceTypeRollupItem[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppResourceTypeRollupItem
 */
export interface AppResourceTypeRollupItem {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppResourceTypeView item = 1;
     */
    item?: AppResourceTypeView;
    /**
     * @generated from protobuf field: int64 resource_count = 2;
     */
    resourceCount: number;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppResourceTypeTraitView
 */
export interface AppResourceTypeTraitView {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppResourceTypeTrait app_resource_type_trait = 1;
     */
    appResourceTypeTrait?: AppResourceTypeTrait;
    /**
     * @generated from protobuf field: string app_path = 2;
     */
    appPath: string;
    /**
     * @generated from protobuf field: string resource_type_path = 3;
     */
    resourceTypePath: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.AppResourceTypeTraitRollupItem
 */
export interface AppResourceTypeTraitRollupItem {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppResourceTypeTraitView item = 1;
     */
    item?: AppResourceTypeTraitView;
    /**
     * @generated from protobuf field: int64 app_resource_type_count = 2;
     */
    appResourceTypeCount: number;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppResourceTypeTraitsRollupRequest
 */
export interface SearchAppResourceTypeTraitsRollupRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string app_id = 3;
     */
    appId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppResourceTypeTraitsRollupResponse
 */
export interface SearchAppResourceTypeTraitsRollupResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppResourceTypeTraitRollupItem list = 1;
     */
    list: AppResourceTypeTraitRollupItem[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppResourceGrant
 */
export interface AppResourceGrant {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppUser appUser = 1;
     */
    appUser?: AppUser;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppEntitlement entitlements = 2;
     */
    entitlements: AppEntitlement[];
    /**
     * @generated from protobuf field: c1.api.user.v1.User user = 3;
     */
    user?: User;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppResourceGrantsRequest
 */
export interface SearchAppResourceGrantsRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * @generated from protobuf field: string app_id = 4;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_resource_id = 5;
     */
    appResourceId: string;
    /**
     * @generated from protobuf field: string app_resource_type_id = 6;
     */
    appResourceTypeId: string;
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppUserType app_user_types = 7;
     */
    appUserTypes: AppUserType[];
    /**
     * @generated from protobuf field: repeated string app_user_status_details = 8;
     */
    appUserStatusDetails: string[];
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppResourceGrantsResponse
 */
export interface SearchAppResourceGrantsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppResourceGrant list = 1;
     */
    list: AppResourceGrant[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.GetAppResourceGrantsSearchTermsRequest
 */
export interface GetAppResourceGrantsSearchTermsRequest {
    /**
     * @generated from protobuf field: c1.api.app.v1.SearchAppResourceGrantsRequest search = 1;
     */
    search?: SearchAppResourceGrantsRequest;
    /**
     * @generated from protobuf field: c1.api.app.v1.GetAppResourceGrantsSearchTermsRequest.TermType term = 2;
     */
    term: GetAppResourceGrantsSearchTermsRequest_TermType;
    /**
     * @generated from protobuf field: string query = 3;
     */
    query: string;
    /**
     * @generated from protobuf field: bool include_count = 4;
     */
    includeCount: boolean;
}
/**
 * @generated from protobuf enum c1.api.app.v1.GetAppResourceGrantsSearchTermsRequest.TermType
 */
export enum GetAppResourceGrantsSearchTermsRequest_TermType {
    /**
     * @generated from protobuf enum value: UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * @generated from protobuf enum value: APP_USER_STATUS_DETAILS = 1;
     */
    APP_USER_STATUS_DETAILS = 1
}
/**
 * @generated from protobuf message c1.api.app.v1.GetAppResourceGrantsSearchTermsResponse
 */
export interface GetAppResourceGrantsSearchTermsResponse {
    /**
     * @generated from protobuf field: c1.api.search.v1.Facets facets = 1;
     */
    facets?: Facets;
}
/**
 * @generated from protobuf message c1.api.app.v1.InactiveResourceOwnerEntry
 */
export interface InactiveResourceOwnerEntry {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppResourceView app_resource_view = 1;
     */
    appResourceView?: AppResourceView;
    /**
     * @generated from protobuf field: repeated c1.api.user.v1.User app_resource_owners = 3;
     */
    appResourceOwners: User[];
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppResourcesWithDeactivatedOwnerRequest
 */
export interface SearchAppResourcesWithDeactivatedOwnerRequest {
    /**
     * @generated from protobuf field: int32 page_size = 1;
     */
    pageSize: number;
    /**
     * @generated from protobuf field: string page_token = 2;
     */
    pageToken: string;
    /**
     * @generated from protobuf field: c1.api.app.v1.AppResourceExpandMask expand_mask = 3;
     */
    expandMask?: AppResourceExpandMask;
}
/**
 * @generated from protobuf message c1.api.app.v1.SearchAppResourcesWithDeactivatedOwnerResponse
 */
export interface SearchAppResourcesWithDeactivatedOwnerResponse {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.InactiveResourceOwnerEntry list = 1;
     */
    list: InactiveResourceOwnerEntry[];
    /**
     * @generated from protobuf field: string next_page_token = 2;
     */
    nextPageToken: string;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 3;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.CreateManuallyManagedResourceRequest
 */
export interface CreateManuallyManagedResourceRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string display_name = 2;
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 3;
     */
    description: string;
    /**
     * @generated from protobuf field: string linked_idp_entitlement_app_id = 4;
     */
    linkedIdpEntitlementAppId: string;
    /**
     * @generated from protobuf field: string linked_idp_entitlement_id = 5;
     */
    linkedIdpEntitlementId: string;
    /**
     * @generated from protobuf field: repeated string resource_owner_user_ids = 6;
     */
    resourceOwnerUserIds: string[];
    /**
     * @generated from protobuf field: c1.api.app.v1.ManuallyManagedResourceType resource_type = 7;
     */
    resourceType: ManuallyManagedResourceType;
    /**
     * @generated from protobuf field: c1.api.app.v1.ManuallyManagedEntitlementSlug entitlement_slug = 8;
     */
    entitlementSlug: ManuallyManagedEntitlementSlug;
    /**
     * @generated from protobuf field: bool is_automation_enabled = 9;
     */
    isAutomationEnabled: boolean;
}
/**
 * @generated from protobuf message c1.api.app.v1.CreateManuallyManagedResourceResponse
 */
export interface CreateManuallyManagedResourceResponse {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementView app_entitlement_view = 1;
     */
    appEntitlementView?: AppEntitlementView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.CreateManuallyManagedAppResourceRequest
 */
export interface CreateManuallyManagedAppResourceRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string display_name = 2;
     */
    displayName: string;
    /**
     * @generated from protobuf field: string description = 3;
     */
    description: string;
    /**
     * @generated from protobuf field: repeated string resource_owner_user_ids = 4;
     */
    resourceOwnerUserIds: string[];
    /**
     * @generated from protobuf field: string app_resource_type_id = 5;
     */
    appResourceTypeId: string;
    /**
     * If supplied, it's implied that the resource is created before sync and needs to be merged with connector resource.
     *
     * @generated from protobuf field: string match_baton_id = 6;
     */
    matchBatonId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.CreateManuallyManagedAppResourceResponse
 */
export interface CreateManuallyManagedAppResourceResponse {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppResource app_resource = 1;
     */
    appResource?: AppResource;
}
/**
 * @generated from protobuf message c1.api.app.v1.DeleteManuallyManagedAppResourceRequest
 */
export interface DeleteManuallyManagedAppResourceRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string app_resource_id = 2;
     */
    appResourceId: string;
    /**
     * @generated from protobuf field: string app_resource_type_id = 3;
     */
    appResourceTypeId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.DeleteManuallyManagedAppResourceResponse
 */
export interface DeleteManuallyManagedAppResourceResponse {
}
/**
 * @generated from protobuf message c1.api.app.v1.DeleteManuallyManagedEntitlementRequest
 */
export interface DeleteManuallyManagedEntitlementRequest {
    /**
     * @generated from protobuf field: string app_id = 1;
     */
    appId: string;
    /**
     * @generated from protobuf field: string entitlement_id = 2;
     */
    entitlementId: string;
}
/**
 * @generated from protobuf message c1.api.app.v1.DeleteManuallyManagedEntitlementResponse
 */
export interface DeleteManuallyManagedEntitlementResponse {
    /**
     * @generated from protobuf field: c1.api.app.v1.AppEntitlementView app_entitlement_view = 1;
     */
    appEntitlementView?: AppEntitlementView;
    /**
     * @generated from protobuf field: repeated google.protobuf.Any expanded = 2;
     */
    expanded: Any[];
}
/**
 * @generated from protobuf message c1.api.app.v1.AppResourceSearchFilter
 */
export interface AppResourceSearchFilter {
    /**
     * @generated from protobuf field: repeated c1.api.app.v1.AppResourceRef refs = 15;
     */
    refs: AppResourceRef[];
}
/**
 * @generated from protobuf enum c1.api.app.v1.ManuallyManagedResourceType
 */
export enum ManuallyManagedResourceType {
    /**
     * @generated from protobuf enum value: ROLE = 0;
     */
    ROLE = 0,
    /**
     * @generated from protobuf enum value: GROUP = 1;
     */
    GROUP = 1,
    /**
     * @generated from protobuf enum value: LICENSE = 2;
     */
    LICENSE = 2,
    /**
     * @generated from protobuf enum value: PROJECT = 3;
     */
    PROJECT = 3,
    /**
     * @generated from protobuf enum value: CATALOG = 4;
     */
    CATALOG = 4,
    /**
     * @generated from protobuf enum value: CUSTOM = 5;
     */
    CUSTOM = 5,
    /**
     * @generated from protobuf enum value: VAULT = 6;
     */
    VAULT = 6,
    /**
     * @generated from protobuf enum value: PROFILE_TYPE = 7;
     */
    PROFILE_TYPE = 7
}
/**
 * @generated from protobuf enum c1.api.app.v1.ManuallyManagedEntitlementSlug
 */
export enum ManuallyManagedEntitlementSlug {
    /**
     * @generated from protobuf enum value: MEMBER = 0;
     */
    MEMBER = 0,
    /**
     * @generated from protobuf enum value: ASSIGNED = 1;
     */
    ASSIGNED = 1,
    /**
     * @generated from protobuf enum value: ENROLLMENT = 2;
     */
    ENROLLMENT = 2,
    /**
     * @generated from protobuf enum value: ADMIN = 3;
     */
    ADMIN = 3,
    /**
     * @generated from protobuf enum value: OWNER = 4;
     */
    OWNER = 4
}
// @generated message type with reflection information, may provide speed optimized methods
class HighRiskRolesAndGrantsCountRequest$Type extends MessageType<HighRiskRolesAndGrantsCountRequest> {
    constructor() {
        super("c1.api.app.v1.HighRiskRolesAndGrantsCountRequest", [
            { no: 1, name: "onGoing", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.HighRiskRolesAndGrantsCountRequest
 */
export const HighRiskRolesAndGrantsCountRequest = new HighRiskRolesAndGrantsCountRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HighRiskRolesAndGrantsCountResponse$Type extends MessageType<HighRiskRolesAndGrantsCountResponse> {
    constructor() {
        super("c1.api.app.v1.HighRiskRolesAndGrantsCountResponse", [
            { no: 1, name: "Count", kind: "scalar", jsonName: "Count", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.HighRiskRolesAndGrantsCountResponse
 */
export const HighRiskRolesAndGrantsCountResponse = new HighRiskRolesAndGrantsCountResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HighRiskRolesAndCountStruct$Type extends MessageType<HighRiskRolesAndCountStruct> {
    constructor() {
        super("c1.api.app.v1.HighRiskRolesAndCountStruct", [
            { no: 1, name: "resource", kind: "message", T: () => AppResource },
            { no: 2, name: "resource_type", kind: "message", T: () => AppResourceType },
            { no: 3, name: "Count", kind: "scalar", jsonName: "Count", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 4, name: "app", kind: "message", T: () => App }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.HighRiskRolesAndCountStruct
 */
export const HighRiskRolesAndCountStruct = new HighRiskRolesAndCountStruct$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HighRiskRolesAndGrantsRequest$Type extends MessageType<HighRiskRolesAndGrantsRequest> {
    constructor() {
        super("c1.api.app.v1.HighRiskRolesAndGrantsRequest", [
            { no: 1, name: "onGoing", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.HighRiskRolesAndGrantsRequest
 */
export const HighRiskRolesAndGrantsRequest = new HighRiskRolesAndGrantsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HighRiskRolesAndGrantsResponse$Type extends MessageType<HighRiskRolesAndGrantsResponse> {
    constructor() {
        super("c1.api.app.v1.HighRiskRolesAndGrantsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => HighRiskRolesAndCountStruct },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.HighRiskRolesAndGrantsResponse
 */
export const HighRiskRolesAndGrantsResponse = new HighRiskRolesAndGrantsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HighRiskRolesAndGrantsEntitlementsRequest$Type extends MessageType<HighRiskRolesAndGrantsEntitlementsRequest> {
    constructor() {
        super("c1.api.app.v1.HighRiskRolesAndGrantsEntitlementsRequest", [
            { no: 1, name: "onGoing", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 2, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 3, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.HighRiskRolesAndGrantsEntitlementsRequest
 */
export const HighRiskRolesAndGrantsEntitlementsRequest = new HighRiskRolesAndGrantsEntitlementsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HighRiskRolesAndGrantsStruct$Type extends MessageType<HighRiskRolesAndGrantsStruct> {
    constructor() {
        super("c1.api.app.v1.HighRiskRolesAndGrantsStruct", [
            { no: 1, name: "resource", kind: "message", T: () => AppResource },
            { no: 2, name: "resource_type", kind: "message", T: () => AppResourceType },
            { no: 4, name: "app", kind: "message", T: () => App },
            { no: 5, name: "app_user", kind: "message", T: () => AppUser },
            { no: 6, name: "entitlement", kind: "message", T: () => AppEntitlement },
            { no: 7, name: "user", kind: "message", T: () => User },
            { no: 8, name: "deprovision_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.HighRiskRolesAndGrantsStruct
 */
export const HighRiskRolesAndGrantsStruct = new HighRiskRolesAndGrantsStruct$Type();
// @generated message type with reflection information, may provide speed optimized methods
class HighRiskRolesAndGrantsEntitlementsResponse$Type extends MessageType<HighRiskRolesAndGrantsEntitlementsResponse> {
    constructor() {
        super("c1.api.app.v1.HighRiskRolesAndGrantsEntitlementsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => HighRiskRolesAndGrantsStruct },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.HighRiskRolesAndGrantsEntitlementsResponse
 */
export const HighRiskRolesAndGrantsEntitlementsResponse = new HighRiskRolesAndGrantsEntitlementsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppResourceExpandMask$Type extends MessageType<AppResourceExpandMask> {
    constructor() {
        super("c1.api.app.v1.AppResourceExpandMask", [
            { no: 1, name: "paths", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { unique: true, items: { string: { in: ["*", "app_id", "app_resource_type_id", "parent_app_resource_type_id", "parent_app_resource_id", "match_baton_id"] } }, ignoreEmpty: true } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppResourceExpandMask
 */
export const AppResourceExpandMask = new AppResourceExpandMask$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppResourceServiceGetRequest$Type extends MessageType<AppResourceServiceGetRequest> {
    constructor() {
        super("c1.api.app.v1.AppResourceServiceGetRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "expand_mask", kind: "message", T: () => AppResourceExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppResourceServiceGetRequest
 */
export const AppResourceServiceGetRequest = new AppResourceServiceGetRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppResourceServiceListRequest$Type extends MessageType<AppResourceServiceListRequest> {
    constructor() {
        super("c1.api.app.v1.AppResourceServiceListRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 4, name: "app_resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^([a-zA-Z0-9]{27}|)$" } } } },
            { no: 5, name: "expand_mask", kind: "message", T: () => AppResourceExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppResourceServiceListRequest
 */
export const AppResourceServiceListRequest = new AppResourceServiceListRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppResourceServiceUpdateRequest$Type extends MessageType<AppResourceServiceUpdateRequest> {
    constructor() {
        super("c1.api.app.v1.AppResourceServiceUpdateRequest", [
            { no: 1, name: "app_resource", kind: "message", T: () => AppResource, options: { "validate.rules": { message: { skip: true } } } },
            { no: 2, name: "update_mask", kind: "message", T: () => FieldMask },
            { no: 3, name: "expand_mask", kind: "message", T: () => AppResourceExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppResourceServiceUpdateRequest
 */
export const AppResourceServiceUpdateRequest = new AppResourceServiceUpdateRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppResourceTypesRequest$Type extends MessageType<SearchAppResourceTypesRequest> {
    constructor() {
        super("c1.api.app.v1.SearchAppResourceTypesRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "exclude_resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 5, name: "resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 7, name: "resource_type_trait_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 8, name: "exclude_resource_type_trait_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 9, name: "app_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 10, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppResourceTypesRequest
 */
export const SearchAppResourceTypesRequest = new SearchAppResourceTypesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppResourceRef$Type extends MessageType<AppResourceRef> {
    constructor() {
        super("c1.api.app.v1.AppResourceRef", [
            { no: 1, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "app_resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppResourceRef
 */
export const AppResourceRef = new AppResourceRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppResourcesRequest$Type extends MessageType<SearchAppResourcesRequest> {
    constructor() {
        super("c1.api.app.v1.SearchAppResourcesRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "exclude_resource_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 5, name: "resource_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 7, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 8, name: "resource_type_trait_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 9, name: "exclude_resource_type_trait_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 10, name: "app_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 11, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppResourceRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32" } } } },
            { no: 12, name: "exclude_deleted_resource_bindings", kind: "scalar", T: 8 /*ScalarType.BOOL*/ },
            { no: 13, name: "owner_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppResourcesRequest
 */
export const SearchAppResourcesRequest = new SearchAppResourcesRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppResourceTypesResponse$Type extends MessageType<SearchAppResourceTypesResponse> {
    constructor() {
        super("c1.api.app.v1.SearchAppResourceTypesResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppResourceType },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppResourceTypesResponse
 */
export const SearchAppResourceTypesResponse = new SearchAppResourceTypesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppResourcesResponse$Type extends MessageType<SearchAppResourcesResponse> {
    constructor() {
        super("c1.api.app.v1.SearchAppResourcesResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppResourceView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppResourcesResponse
 */
export const SearchAppResourcesResponse = new SearchAppResourcesResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppResourceView$Type extends MessageType<AppResourceView> {
    constructor() {
        super("c1.api.app.v1.AppResourceView", [
            { no: 1, name: "app_resource", kind: "message", T: () => AppResource },
            { no: 2, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "resource_type_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "parent_resource_type_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "parent_resource_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "object_permissions", kind: "message", T: () => ActorObjectPermissions }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppResourceView
 */
export const AppResourceView = new AppResourceView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppResource$Type extends MessageType<AppResource> {
    constructor() {
        super("c1.api.app.v1.AppResource", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "app_resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 7, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "512" } } } },
            { no: 8, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "2048" } } } },
            { no: 9, name: "custom_description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "2048" } } } },
            { no: 10, name: "grant_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 11, name: "parent_app_resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 12, name: "parent_app_resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 100, name: "secret_trait", kind: "message", oneof: "metadata", T: () => SecretTrait },
            { no: 13, name: "match_baton_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 14, name: "profile", kind: "message", T: () => Struct, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "App Resource" } }] }, "policy.v1.msg": { enabled: true, name: "app_resource", keyFields: ["id", "app_resource_type_id", "app_id"] } });
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppResource
 */
export const AppResource = new AppResource$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SecretTrait$Type extends MessageType<SecretTrait> {
    constructor() {
        super("c1.api.app.v1.SecretTrait", [
            { no: 1, name: "identity_app_user_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "secret_created_at", kind: "message", T: () => Timestamp },
            { no: 3, name: "secret_expires_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "last_used_at", kind: "message", T: () => Timestamp }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SecretTrait
 */
export const SecretTrait = new SecretTrait$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppResourceTypeRef$Type extends MessageType<AppResourceTypeRef> {
    constructor() {
        super("c1.api.app.v1.AppResourceTypeRef", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppResourceTypeRef
 */
export const AppResourceTypeRef = new AppResourceTypeRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppResourceType$Type extends MessageType<AppResourceType> {
    constructor() {
        super("c1.api.app.v1.AppResourceType", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "512" } } } },
            { no: 7, name: "trait_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } }
        ], { "apigw.v1.message": { messageOptions: [{ terraformEntity: { name: "App Resource Type" } }] }, "policy.v1.msg": { enabled: true, name: "app_resource_type", keyFields: ["id", "app_id"] } });
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppResourceType
 */
export const AppResourceType = new AppResourceType$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppResourceTypeView$Type extends MessageType<AppResourceTypeView> {
    constructor() {
        super("c1.api.app.v1.AppResourceTypeView", [
            { no: 1, name: "app_resource_type", kind: "message", T: () => AppResourceType },
            { no: 2, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppResourceTypeView
 */
export const AppResourceTypeView = new AppResourceTypeView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppResourceTypeTrait$Type extends MessageType<AppResourceTypeTrait> {
    constructor() {
        super("c1.api.app.v1.AppResourceTypeTrait", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "created_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 4, name: "updated_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 5, name: "deleted_at", kind: "message", T: () => Timestamp, options: { "apigw.v1.field": { fieldOptions: [{ readOnlySpec: true }] } } },
            { no: 6, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "512" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppResourceTypeTrait
 */
export const AppResourceTypeTrait = new AppResourceTypeTrait$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppResourceServiceGetResponse$Type extends MessageType<AppResourceServiceGetResponse> {
    constructor() {
        super("c1.api.app.v1.AppResourceServiceGetResponse", [
            { no: 1, name: "app_resource_view", kind: "message", T: () => AppResourceView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppResourceServiceGetResponse
 */
export const AppResourceServiceGetResponse = new AppResourceServiceGetResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppResourceServiceListResponse$Type extends MessageType<AppResourceServiceListResponse> {
    constructor() {
        super("c1.api.app.v1.AppResourceServiceListResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppResourceView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any },
            { no: 3, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppResourceServiceListResponse
 */
export const AppResourceServiceListResponse = new AppResourceServiceListResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppResourceServiceUpdateResponse$Type extends MessageType<AppResourceServiceUpdateResponse> {
    constructor() {
        super("c1.api.app.v1.AppResourceServiceUpdateResponse", [
            { no: 1, name: "app_resource_view", kind: "message", T: () => AppResourceView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppResourceServiceUpdateResponse
 */
export const AppResourceServiceUpdateResponse = new AppResourceServiceUpdateResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppResourceRollupItem$Type extends MessageType<AppResourceRollupItem> {
    constructor() {
        super("c1.api.app.v1.AppResourceRollupItem", [
            { no: 1, name: "item", kind: "message", T: () => AppResourceView },
            { no: 2, name: "entitlements", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlement }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppResourceRollupItem
 */
export const AppResourceRollupItem = new AppResourceRollupItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppResourceRollupRequest$Type extends MessageType<SearchAppResourceRollupRequest> {
    constructor() {
        super("c1.api.app.v1.SearchAppResourceRollupRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "exclude_resource_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 5, name: "resource_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 6, name: "resource_type_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { minBytes: "3", maxBytes: "512" } } } } } },
            { no: 8, name: "resource_type_trait_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 9, name: "exclude_resource_type_trait_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 10, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 11, name: "risk_level_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 12, name: "compliance_framework_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 13, name: "exclude_app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 14, name: "exclude_automated_resources", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppResourceRollupRequest
 */
export const SearchAppResourceRollupRequest = new SearchAppResourceRollupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppResourceRollupResponse$Type extends MessageType<SearchAppResourceRollupResponse> {
    constructor() {
        super("c1.api.app.v1.SearchAppResourceRollupResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppResourceRollupItem },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppResourceRollupResponse
 */
export const SearchAppResourceRollupResponse = new SearchAppResourceRollupResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppResourceTypesRollupRequest$Type extends MessageType<SearchAppResourceTypesRollupRequest> {
    constructor() {
        super("c1.api.app.v1.SearchAppResourceTypesRollupRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "app_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", items: { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } } } },
            { no: 5, name: "exclude_automated_resources", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppResourceTypesRollupRequest
 */
export const SearchAppResourceTypesRollupRequest = new SearchAppResourceTypesRollupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppResourceTypesRollupResponse$Type extends MessageType<SearchAppResourceTypesRollupResponse> {
    constructor() {
        super("c1.api.app.v1.SearchAppResourceTypesRollupResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppResourceTypeRollupItem },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppResourceTypesRollupResponse
 */
export const SearchAppResourceTypesRollupResponse = new SearchAppResourceTypesRollupResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppResourceTypeRollupItem$Type extends MessageType<AppResourceTypeRollupItem> {
    constructor() {
        super("c1.api.app.v1.AppResourceTypeRollupItem", [
            { no: 1, name: "item", kind: "message", T: () => AppResourceTypeView },
            { no: 2, name: "resource_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppResourceTypeRollupItem
 */
export const AppResourceTypeRollupItem = new AppResourceTypeRollupItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppResourceTypeTraitView$Type extends MessageType<AppResourceTypeTraitView> {
    constructor() {
        super("c1.api.app.v1.AppResourceTypeTraitView", [
            { no: 1, name: "app_resource_type_trait", kind: "message", T: () => AppResourceTypeTrait },
            { no: 2, name: "app_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "resource_type_path", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppResourceTypeTraitView
 */
export const AppResourceTypeTraitView = new AppResourceTypeTraitView$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppResourceTypeTraitRollupItem$Type extends MessageType<AppResourceTypeTraitRollupItem> {
    constructor() {
        super("c1.api.app.v1.AppResourceTypeTraitRollupItem", [
            { no: 1, name: "item", kind: "message", T: () => AppResourceTypeTraitView },
            { no: 2, name: "app_resource_type_count", kind: "scalar", T: 3 /*ScalarType.INT64*/, L: 2 /*LongType.NUMBER*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppResourceTypeTraitRollupItem
 */
export const AppResourceTypeTraitRollupItem = new AppResourceTypeTraitRollupItem$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppResourceTypeTraitsRollupRequest$Type extends MessageType<SearchAppResourceTypeTraitsRollupRequest> {
    constructor() {
        super("c1.api.app.v1.SearchAppResourceTypeTraitsRollupRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppResourceTypeTraitsRollupRequest
 */
export const SearchAppResourceTypeTraitsRollupRequest = new SearchAppResourceTypeTraitsRollupRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppResourceTypeTraitsRollupResponse$Type extends MessageType<SearchAppResourceTypeTraitsRollupResponse> {
    constructor() {
        super("c1.api.app.v1.SearchAppResourceTypeTraitsRollupResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppResourceTypeTraitRollupItem },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppResourceTypeTraitsRollupResponse
 */
export const SearchAppResourceTypeTraitsRollupResponse = new SearchAppResourceTypeTraitsRollupResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppResourceGrant$Type extends MessageType<AppResourceGrant> {
    constructor() {
        super("c1.api.app.v1.AppResourceGrant", [
            { no: 1, name: "appUser", kind: "message", T: () => AppUser },
            { no: 2, name: "entitlements", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppEntitlement },
            { no: 3, name: "user", kind: "message", T: () => User }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppResourceGrant
 */
export const AppResourceGrant = new AppResourceGrant$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppResourceGrantsRequest$Type extends MessageType<SearchAppResourceGrantsRequest> {
    constructor() {
        super("c1.api.app.v1.SearchAppResourceGrantsRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 4, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{0,27}$" } } } },
            { no: 5, name: "app_resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 6, name: "app_resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^([a-zA-Z0-9]{27}|)$" } } } },
            { no: 7, name: "app_user_types", kind: "enum", repeat: 1 /*RepeatType.PACKED*/, T: () => ["c1.api.app.v1.AppUserType", AppUserType, "APP_USER_TYPE_"], options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { enum: { definedOnly: true } } } } } },
            { no: 8, name: "app_user_status_details", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "32", unique: true, items: { string: { minBytes: "1", maxBytes: "1024" } } } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppResourceGrantsRequest
 */
export const SearchAppResourceGrantsRequest = new SearchAppResourceGrantsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppResourceGrantsResponse$Type extends MessageType<SearchAppResourceGrantsResponse> {
    constructor() {
        super("c1.api.app.v1.SearchAppResourceGrantsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppResourceGrant },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppResourceGrantsResponse
 */
export const SearchAppResourceGrantsResponse = new SearchAppResourceGrantsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAppResourceGrantsSearchTermsRequest$Type extends MessageType<GetAppResourceGrantsSearchTermsRequest> {
    constructor() {
        super("c1.api.app.v1.GetAppResourceGrantsSearchTermsRequest", [
            { no: 1, name: "search", kind: "message", T: () => SearchAppResourceGrantsRequest },
            { no: 2, name: "term", kind: "enum", T: () => ["c1.api.app.v1.GetAppResourceGrantsSearchTermsRequest.TermType", GetAppResourceGrantsSearchTermsRequest_TermType] },
            { no: 3, name: "query", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 4, name: "include_count", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetAppResourceGrantsSearchTermsRequest
 */
export const GetAppResourceGrantsSearchTermsRequest = new GetAppResourceGrantsSearchTermsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetAppResourceGrantsSearchTermsResponse$Type extends MessageType<GetAppResourceGrantsSearchTermsResponse> {
    constructor() {
        super("c1.api.app.v1.GetAppResourceGrantsSearchTermsResponse", [
            { no: 1, name: "facets", kind: "message", T: () => Facets }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.GetAppResourceGrantsSearchTermsResponse
 */
export const GetAppResourceGrantsSearchTermsResponse = new GetAppResourceGrantsSearchTermsResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class InactiveResourceOwnerEntry$Type extends MessageType<InactiveResourceOwnerEntry> {
    constructor() {
        super("c1.api.app.v1.InactiveResourceOwnerEntry", [
            { no: 1, name: "app_resource_view", kind: "message", T: () => AppResourceView },
            { no: 3, name: "app_resource_owners", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => User }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.InactiveResourceOwnerEntry
 */
export const InactiveResourceOwnerEntry = new InactiveResourceOwnerEntry$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppResourcesWithDeactivatedOwnerRequest$Type extends MessageType<SearchAppResourcesWithDeactivatedOwnerRequest> {
    constructor() {
        super("c1.api.app.v1.SearchAppResourcesWithDeactivatedOwnerRequest", [
            { no: 1, name: "page_size", kind: "scalar", T: 5 /*ScalarType.INT32*/, options: { "validate.rules": { int32: { lte: 100, gte: 0 } } } },
            { no: 2, name: "page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "1024" } } } },
            { no: 3, name: "expand_mask", kind: "message", T: () => AppResourceExpandMask }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppResourcesWithDeactivatedOwnerRequest
 */
export const SearchAppResourcesWithDeactivatedOwnerRequest = new SearchAppResourcesWithDeactivatedOwnerRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class SearchAppResourcesWithDeactivatedOwnerResponse$Type extends MessageType<SearchAppResourcesWithDeactivatedOwnerResponse> {
    constructor() {
        super("c1.api.app.v1.SearchAppResourcesWithDeactivatedOwnerResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => InactiveResourceOwnerEntry },
            { no: 2, name: "next_page_token", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.SearchAppResourcesWithDeactivatedOwnerResponse
 */
export const SearchAppResourcesWithDeactivatedOwnerResponse = new SearchAppResourcesWithDeactivatedOwnerResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateManuallyManagedResourceRequest$Type extends MessageType<CreateManuallyManagedResourceRequest> {
    constructor() {
        super("c1.api.app.v1.CreateManuallyManagedResourceRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "512" } }, "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "2048" } } } },
            { no: 4, name: "linked_idp_entitlement_app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 5, name: "linked_idp_entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 6, name: "resource_owner_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "4" } } } },
            { no: 7, name: "resource_type", kind: "enum", T: () => ["c1.api.app.v1.ManuallyManagedResourceType", ManuallyManagedResourceType], options: { "validate.rules": { enum: { definedOnly: true } } } },
            { no: 8, name: "entitlement_slug", kind: "enum", T: () => ["c1.api.app.v1.ManuallyManagedEntitlementSlug", ManuallyManagedEntitlementSlug], options: { "validate.rules": { enum: { definedOnly: true } } } },
            { no: 9, name: "is_automation_enabled", kind: "scalar", T: 8 /*ScalarType.BOOL*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CreateManuallyManagedResourceRequest
 */
export const CreateManuallyManagedResourceRequest = new CreateManuallyManagedResourceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateManuallyManagedResourceResponse$Type extends MessageType<CreateManuallyManagedResourceResponse> {
    constructor() {
        super("c1.api.app.v1.CreateManuallyManagedResourceResponse", [
            { no: 1, name: "app_entitlement_view", kind: "message", T: () => AppEntitlementView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CreateManuallyManagedResourceResponse
 */
export const CreateManuallyManagedResourceResponse = new CreateManuallyManagedResourceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateManuallyManagedAppResourceRequest$Type extends MessageType<CreateManuallyManagedAppResourceRequest> {
    constructor() {
        super("c1.api.app.v1.CreateManuallyManagedAppResourceRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } }, "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } },
            { no: 2, name: "display_name", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "3", maxBytes: "512" } }, "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } },
            { no: 3, name: "description", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { minBytes: "0", maxBytes: "2048" } } } },
            { no: 4, name: "resource_owner_user_ids", kind: "scalar", repeat: 2 /*RepeatType.UNPACKED*/, T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "4" } } } },
            { no: 5, name: "app_resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } }, "apigw.v1.field": { fieldOptions: [{ requiredSpec: true }] } } },
            { no: 6, name: "match_baton_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CreateManuallyManagedAppResourceRequest
 */
export const CreateManuallyManagedAppResourceRequest = new CreateManuallyManagedAppResourceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class CreateManuallyManagedAppResourceResponse$Type extends MessageType<CreateManuallyManagedAppResourceResponse> {
    constructor() {
        super("c1.api.app.v1.CreateManuallyManagedAppResourceResponse", [
            { no: 1, name: "app_resource", kind: "message", T: () => AppResource }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.CreateManuallyManagedAppResourceResponse
 */
export const CreateManuallyManagedAppResourceResponse = new CreateManuallyManagedAppResourceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteManuallyManagedAppResourceRequest$Type extends MessageType<DeleteManuallyManagedAppResourceRequest> {
    constructor() {
        super("c1.api.app.v1.DeleteManuallyManagedAppResourceRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "app_resource_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 3, name: "app_resource_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.DeleteManuallyManagedAppResourceRequest
 */
export const DeleteManuallyManagedAppResourceRequest = new DeleteManuallyManagedAppResourceRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteManuallyManagedAppResourceResponse$Type extends MessageType<DeleteManuallyManagedAppResourceResponse> {
    constructor() {
        super("c1.api.app.v1.DeleteManuallyManagedAppResourceResponse", []);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.DeleteManuallyManagedAppResourceResponse
 */
export const DeleteManuallyManagedAppResourceResponse = new DeleteManuallyManagedAppResourceResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteManuallyManagedEntitlementRequest$Type extends MessageType<DeleteManuallyManagedEntitlementRequest> {
    constructor() {
        super("c1.api.app.v1.DeleteManuallyManagedEntitlementRequest", [
            { no: 1, name: "app_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } },
            { no: 2, name: "entitlement_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.DeleteManuallyManagedEntitlementRequest
 */
export const DeleteManuallyManagedEntitlementRequest = new DeleteManuallyManagedEntitlementRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DeleteManuallyManagedEntitlementResponse$Type extends MessageType<DeleteManuallyManagedEntitlementResponse> {
    constructor() {
        super("c1.api.app.v1.DeleteManuallyManagedEntitlementResponse", [
            { no: 1, name: "app_entitlement_view", kind: "message", T: () => AppEntitlementView },
            { no: 2, name: "expanded", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => Any }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.DeleteManuallyManagedEntitlementResponse
 */
export const DeleteManuallyManagedEntitlementResponse = new DeleteManuallyManagedEntitlementResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class AppResourceSearchFilter$Type extends MessageType<AppResourceSearchFilter> {
    constructor() {
        super("c1.api.app.v1.AppResourceSearchFilter", [
            { no: 15, name: "refs", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => AppResourceRef, options: { "validate.rules": { repeated: { minItems: "0", maxItems: "500" } } } }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message c1.api.app.v1.AppResourceSearchFilter
 */
export const AppResourceSearchFilter = new AppResourceSearchFilter$Type();
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.AppResourceService
 */
export const AppResourceService = new ServiceType("c1.api.app.v1.AppResourceService", [
    { name: "Get", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/resource_types/{app_resource_type_id}/resources/{id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "App Resource" }], group: "App Resource" }] } }, I: AppResourceServiceGetRequest, O: AppResourceServiceGetResponse },
    { name: "List", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "GET", route: "/api/v1/apps/{app_id}/resource_types/{app_resource_type_id}/resources", query: { page_size: "page_size", page_token: "page_token" }, group: "App Resource" }] } }, I: AppResourceServiceListRequest, O: AppResourceServiceListResponse },
    { name: "Update", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app_resource.app_id}/resource_types/{app_resource.app_resource_type_id}/resources/{app_resource.id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_UPDATE", name: "App Resource" }], group: "App Resource" }] } }, I: AppResourceServiceUpdateRequest, O: AppResourceServiceUpdateResponse },
    { name: "CreateManuallyManagedResource", options: { "authz.method": { role: "EDITOR" } }, I: CreateManuallyManagedResourceRequest, O: CreateManuallyManagedResourceResponse },
    { name: "CreateManuallyManagedAppResource", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/apps/{app_id}/resource_types/{app_resource_type_id}/resources", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_CREATE", name: "App Resource" }], group: "App Resource" }] } }, I: CreateManuallyManagedAppResourceRequest, O: CreateManuallyManagedAppResourceResponse },
    { name: "DeleteManuallyManagedAppResource", options: { "authz.method": { role: "EDITOR" }, "apigw.v1.method": { operations: [{ method: "DELETE", route: "/api/v1/apps/{app_id}/resource_types/{app_resource_type_id}/resources/{app_resource_id}", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_DELETE", name: "App Resource" }], group: "App Resource" }] } }, I: DeleteManuallyManagedAppResourceRequest, O: DeleteManuallyManagedAppResourceResponse },
    { name: "DeleteManuallyManagedEntitlement", options: { "authz.method": { role: "EDITOR" } }, I: DeleteManuallyManagedEntitlementRequest, O: DeleteManuallyManagedEntitlementResponse }
]);
/**
 * @generated ServiceType for protobuf service c1.api.app.v1.AppResourceSearch
 */
export const AppResourceSearch = new ServiceType("c1.api.app.v1.AppResourceSearch", [
    { name: "SearchAppResourceTypes", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/search/app_resource_types", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "App Resource Type", optionalExclusion: "OPTIONAL_EXCLUSION_DATA_SOURCE_ONLY" }, { type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "App Resource Types", optionalExclusion: "OPTIONAL_EXCLUSION_DATA_SOURCE_ONLY" }], group: "App Resource", pagination: { type: "TERRAFORM_ENTITY_PAGINATION_TYPE_CURSOR", inputs: [{ name: "pageToken", in: "TERRAFORM_ENTITY_PAGINATION_INPUT_IN_REQUEST_BODY", type: "TERRAFORM_ENTITY_PAGINATION_INPUT_TYPE_CURSOR" }], outputs: { nextCursor: "$.nextPageToken" } } }] } }, I: SearchAppResourceTypesRequest, O: SearchAppResourceTypesResponse },
    { name: "SearchAppResources", options: { "authz.method": { role: "VIEWER" }, "apigw.v1.method": { operations: [{ method: "POST", route: "/api/v1/search/app_resources", terraformEntity: [{ type: "TERRAFORM_ENTITY_METHOD_TYPE_READ", name: "App Resources", optionalExclusion: "OPTIONAL_EXCLUSION_DATA_SOURCE_ONLY" }], group: "App Resource", pagination: { type: "TERRAFORM_ENTITY_PAGINATION_TYPE_CURSOR", inputs: [{ name: "pageToken", in: "TERRAFORM_ENTITY_PAGINATION_INPUT_IN_REQUEST_BODY", type: "TERRAFORM_ENTITY_PAGINATION_INPUT_TYPE_CURSOR" }], outputs: { nextCursor: "$.nextPageToken" } } }] } }, I: SearchAppResourcesRequest, O: SearchAppResourcesResponse },
    { name: "SearchAppResourcesRollup", options: { "authz.method": { role: "VIEWER" } }, I: SearchAppResourceRollupRequest, O: SearchAppResourceRollupResponse },
    { name: "SearchAppResourceTypeTraitsRollup", options: { "authz.method": { role: "VIEWER" } }, I: SearchAppResourceTypeTraitsRollupRequest, O: SearchAppResourceTypeTraitsRollupResponse },
    { name: "SearchAppResourcesWithDeactivatedOwner", options: { "authz.method": { role: "VIEWER" } }, I: SearchAppResourcesWithDeactivatedOwnerRequest, O: SearchAppResourcesWithDeactivatedOwnerResponse },
    { name: "HighRiskRolesAndGrants", options: { "authz.method": { role: "VIEWER" } }, I: HighRiskRolesAndGrantsRequest, O: HighRiskRolesAndGrantsResponse },
    { name: "HighRiskRolesAndGrantsCount", options: { "authz.method": { role: "VIEWER" } }, I: HighRiskRolesAndGrantsCountRequest, O: HighRiskRolesAndGrantsCountResponse },
    { name: "HighRiskRolesAndGrantsEntitlements", options: { "authz.method": { role: "VIEWER" } }, I: HighRiskRolesAndGrantsEntitlementsRequest, O: HighRiskRolesAndGrantsEntitlementsResponse },
    { name: "GetAppResourceGrantsSearchTerms", options: { "authz.method": { role: "VIEWER" } }, I: GetAppResourceGrantsSearchTermsRequest, O: GetAppResourceGrantsSearchTermsResponse },
    { name: "SearchAppResourceGrants", options: { "authz.method": { role: "VIEWER" } }, I: SearchAppResourceGrantsRequest, O: SearchAppResourceGrantsResponse },
    { name: "SearchAppResourceTypesRollup", options: { "authz.method": { role: "VIEWER" } }, I: SearchAppResourceTypesRollupRequest, O: SearchAppResourceTypesRollupResponse }
]);
